var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showNumber)?_c('label-users',{attrs:{"value":_vm.issue.interesteds}}):_vm._e(),(_vm.showNumber)?_c('v-chip',{attrs:{"label":"","color":_vm.colorChip,"disabled":""}},[_vm._v(_vm._s(_vm.issue.interesteds.length))]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }